const isOurselves = (party) => (
  !!party.self
);

export default isOurselves;
